// Profile of Alina Tselinina, Italian. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina è software engineer con un background in data engineering, matematica applicata e machine learning e lavora oggi su applicazioni basate sull’IA e su sistemi agentici. Ha esperienza nella creazione di API e pipeline di dati, nella modernizzazione di applicazioni tramite migrazione al cloud e nello sviluppo di servizi basati su ML. Si concentra sul collegare LLM e agenti di IA a sistemi software affidabili attraverso workflow strutturati, integrazioni, test e valutazione iterativa.',
  imageAlt: 'Ritratto di Alina Tselinina',
  personal: {
    languages: 'Inglese, polacco',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Studi: matematica finanziaria e attuariale',
      institution: 'Università Adam Mickiewicz, Poznań',
      degree: 'Titolo: laurea magistrale'
    },
    {
      period: '2009 - 2014',
      field: 'Studi: matematica',
      institution: 'Università statale bielorussa, Minsk',
      degree: 'Titolo: laurea di primo livello'
    }
  ],
  skills: [
    {
      title: 'Programmazione',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'IA e LLM',
      description: 'Claude, MCP, agenti di IA, adattamento di LLM, addestramento e valutazione di modelli'
    },
    {
      title: 'Cloud e dati',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Framework e API',
      description: 'FastAPI, Flask, Shiny, API REST, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Data engineering e DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Database e orchestrazione',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Strumenti Atlassian',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'Da marzo 2026',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Ingegneria di agenti di IA, configurazione di workflow e integrazione di strumenti.',
        'Adattamento di LLM, addestramento e valutazione di modelli.',
        'Sviluppo e integrazione di applicazioni basate sull’IA.',
        'Calcolo quantistico: contributo allo sviluppo software per applicazioni quantistiche.'
      ]
    },
    {
      period: 'Da maggio 2025',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Sviluppo di app.',
        'Implementazione di unit test e test dell’interfaccia utente a supporto della qualità delle applicazioni.'
      ]
    },
    {
      period: 'Novembre 2022 - febbraio 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Manutenzione e miglioramento di pipeline di dati e dell’orchestrazione dei workflow.',
        'Sviluppo di pacchetti per l’automazione dei report.'
      ]
    },
    {
      period: 'Luglio 2022 - ottobre 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Sviluppo e manutenzione di pipeline ETL.'
      ]
    },
    {
      period: 'Marzo 2022 - giugno 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Progettazione e sviluppo di API REST e servizi di back-end.',
        'Implementazione della logica di backend per l’elaborazione di JSON.'
      ]
    },
    {
      period: 'Novembre 2020 - marzo 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Progettazione e sviluppo di API REST e servizi di back-end (proof of concept).',
        'Sviluppo e manutenzione di pipeline ETL.',
        'Modernizzazione di applicazioni on-premise tramite migrazione ad AWS e riscrittura di codice R in Python.',
        'Validazione XML e trasformazione in HTML.',
        'Sviluppo di applicazioni web.'
      ]
    },
    {
      period: 'Maggio 2020 - novembre 2020',
      title: 'Data Scientist, PSI Polska, Poznań',
      description: [
        'Progettazione e sviluppo di API REST e servizi di back-end con un modello di machine learning nel back-end.',
        'Sviluppo di un modello di segmentazione dei clienti.'
      ]
    },
    {
      period: 'Gennaio 2019 - aprile 2020',
      title: 'Advanced Data Scientist, Analyx, Poznań',
      description: [
        'Web scraping e sviluppo di pipeline di dati.',
        'Sviluppo di applicazioni web.',
        'Modellazione del marketing mix.',
        'Ottimizzazione dei flussi di lavoro.'
      ]
    },
    {
      period: 'Maggio 2018 - dicembre 2018',
      title: 'Data Scientist, Poznań',
      description: [
        'Sviluppo di un processo ETL.',
        'Manutenzione di script Bash.',
        'Assistenza ai clienti e analisi ad hoc.'
      ]
    },
    {
      period: 'Aprile 2017 - aprile 2018',
      title: 'Junior Analyst, Poznań',
      description: [
        'Analisi dei dati e creazione di report.',
        'Preparazione di documentazione e presentazioni.'
      ]
    }
  ]
};
